import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ticket-graphic-small-bottom',
  templateUrl: './ticket-graphic-small-bottom.component.html',
  styleUrls: ['./ticket-graphic-small-bottom.component.scss'],
})
export class TicketGraphicSmallBottomComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
